module.exports = __webpack_public_path__ + "img/other3.76403f0d.png";